import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  EvenementSpontaneState,
  loadEvenementSpontanesAction,
  loadEvenementSpontanesErrorAction,
  loadEvenementSpontanesSuccessAction,
  selectIsEvenementSpontaneInitialized,
} from './evenement-spontane.store';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { EsService } from '../../_services/http/es.service';

@Injectable()
export class EvenementSpontaneEffect {
  constructor(
    private service: EsService,
    private actions$: Actions,
    private store: Store<EvenementSpontaneState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEvenementSpontanesAction),
      withLatestFrom(this.store.select(selectIsEvenementSpontaneInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadEvenementSpontanesSuccessAction({ payload })),
          catchError(() => of(loadEvenementSpontanesErrorAction()))
        )
      )
    )
  );
}
